import { render } from "./ChevronDoubleLeftIcon.vue?vue&type=template&id=0b61ff7b"
import script from "./ChevronDoubleLeftIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleLeftIcon.vue?vue&type=script&lang=js"
script.render = render

export default script